const $ = jQuery;

function languageSwitchHandler(languageSwitch) {
    languageSwitch.on('input', function () {
        setTimeout(function () {
            let path = languageSwitch.data('path');
            let lang = languageSwitch.data('language');
            let langPath = null;

            switch (lang) {
                case 'en':
                    langPath = path.slice(3, path.length);
                    break;
                case 'da':
                    langPath = lang + path;
                    break;
            }
            window.location.href = langPath;
        }, 1500);
    });
}

function sliderInputHandler(lang, sliderInput) {
    if (lang === 'en') {
        sliderInput.prop('checked', true);
    } else {
        sliderInput.prop('checked', false);
    }
}

Drupal.behaviors.lfSwitchLanguage = {
    attach: function (context, settings) {
        let languageSwitch = $('#language-switch', context);
        let lang = languageSwitch.data('language');
        let sliderInput = $('.slider-input', context);

        sliderInputHandler(lang, sliderInput);
        languageSwitchHandler(languageSwitch);
    },
};
